import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@up2stay/up2promo-ui';

import { useDictionary } from '@/core/providers/dictionary-provider';

interface LogoutConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function LogoutConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
}: LogoutConfirmDialogProps) {
  const dict = useDictionary();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-logout-confirm-dialog="">
        <AlertDialogHeader>
          <AlertDialogTitle>{dict.nav.logoutConfirmTitle}</AlertDialogTitle>
          <AlertDialogDescription>
            {dict.nav.logoutConfirmDescription}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{dict.nav.logoutConfirmCancel}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} variant="destructive">
            {dict.nav.logoutConfirmAction}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
